import { Link } from "react-router-dom";
import { AppBar, Box, Toolbar } from "@mui/material";
import AddReactionOutlinedIcon from "@mui/icons-material/AddReactionOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SpaOutlinedIcon from "@mui/icons-material/SpaOutlined";
// import SettingsIcon from "@mui/icons-material/Settings";
import RestoreIcon from "@mui/icons-material/Restore";
import Typography from "@mui/material/Typography";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#e6eaef" : "#e8bab7",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#61798e" : "#61798e",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#61798e" : "#e6eaef",
    borderRadius: 20 / 2,
  },
}));

export default function Nav() {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const getStoredTheme = () => {
    try {
      if (localStorage.getItem("userData") !== null) {
        if (userData.theme) {
          return userData.theme;
        }
      }
    } catch (e) {
      console.log(`error reading theme from local storage ${e}`);
    }
    return "light";
  };

  const persistTheme = (theme) => {
    try {
      const storedUserData = localStorage.getItem("userData");
      let userData;
      if (storedUserData) {
        userData = JSON.parse(storedUserData);
        userData.theme = theme;
      } else {
        userData = { theme: theme };
      }
      localStorage.setItem("userData", JSON.stringify(userData));
      setTheme(theme);
    } catch (e) {
      console.log(`error setting theme to local storage ${e}`);
    }
  };

  const [theme, setTheme] = useState(getStoredTheme());

  // ("light");
  const toggleTheme = () => {
    console.log(`switching theme from ${theme}`);
    if (theme === "light") {
      persistTheme("dark");
    } else {
      persistTheme("light");
    }
  };

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  return (
    <Box sx={{ flexGrow: 1 }} className={`App ${theme}`}>
      <nav>
        <AppBar
          color='inherit'
          position='fixed'
          className='navBar'
          sx={{
            "@media (max-width:900px)": { top: "auto", bottom: 0 },
          }}>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "space-between" },
              alignItems: "center",
              ml: { xs: 0, sm: 2 },
            }}>
            <Typography
              variant='h2'
              noWrap
              component='a'
              href='/'
              className='navLogo'
              sx={{
                mr: 1,
                display: { xs: "none", md: "flex" },
                fontSize: "2.4rem",
                fontFamily: "Vidaloka",
                letterSpacing: ".3rem",
                fontWeight: 100,
              }}>
              NICHI
            </Typography>
            {/* menu */}
            <Box
              sx={{
                gap: { xs: 0, sm: 1 },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "@media(maxWidth(300px)": { flexWrap: "wrap" },
              }}>
              {userData?.username && (
                <>
                  <Link to='/'>
                    <HomeOutlinedIcon
                      edge='start'
                      color='inherit'
                      aria-label='home'
                      sx={{
                        mx: 2,
                        "@media(maxWidth(450px)": { mx: 0.5 },
                      }}
                      className='navIcon'
                    />
                  </Link>
                  <Link to='/mood-tracker'>
                    <AddReactionOutlinedIcon
                      edge='start'
                      color='inherit'
                      aria-label='mood'
                      sx={{
                        mx: 2,
                        "@media(maxWidth(450px)": { mx: 0.5 },
                      }}
                      className='navIcon'
                    />
                  </Link>
                  <Link to='/meditation'>
                    <SpaOutlinedIcon
                      edge='start'
                      color='inherit'
                      aria-label='user'
                      sx={{
                        mx: 2,
                        "@media(maxWidth(450px)": { mx: 0.5 },
                      }}
                      className='navIcon'
                    />
                  </Link>
                  <Link to='/activity-log'>
                    <RestoreIcon
                      edge='start'
                      color='inherit'
                      aria-label='user'
                      sx={{
                        mx: 2,
                        "@media(maxWidth(450px)": { mx: 0.5 },
                      }}
                      className='navIcon'
                    />
                  </Link>
                </>
              )}
              <FormControlLabel
                onClick={toggleTheme}
                control={
                  <MaterialUISwitch
                    sx={{ m: 1 }}
                    defaultChecked={theme === "light"}
                  />
                }
              />
              {/* <button onClick={toggleTheme}>Toggle Theme</button> */}
            </Box>
            {/* menu end */}

            {/* <SettingsIcon
              size="large"
              edge="start"
              color="inherit"
              aria-label="settings"
              sx={{ mr: 4 }}
            /> */}
          </Toolbar>
        </AppBar>
      </nav>
    </Box>
  );
}
